import { RegisterModule } from '@/typings/common'
import {
  DataCollection as Data,
  DataCollectionCollection as Collection,
} from '@/typings/api/DataCollection'
import { DataCollectionsApi as Api } from '@/api/resources'

import { registerModule as vuexRegisterModule } from 'vuex-smart-module'
import { Builder } from '@/store/createCrudModule'
import { PublicationDataCollectionsAdapter as Adapter } from './PublicationDataCollectionsAdapter'
import { MODULE_NAME } from '../utils'


const useOptions = () => ({
  adapter: new Adapter(),
  idName: 'id' as const,
})

const storeModule = Builder<Data, Collection, Api>(useOptions)
export { storeModule as PublicationDataCollectionsStoreModule }

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
